/**
 * The key a product goes by in config/pricing -- settings.productSalesEnabled
 * and, for some products, the pricing feed: its id without the hyphen.
 *
 * Shared by the product page, which disables its buy button when sales are
 * off, and the products grid, which has to say the same thing. The grid used
 * to have no idea: with Roblox sales switched off it still showed "from €10 a
 * week" and a View button like any title you could buy.
 */
const SALES_KEYS: Record<string, string> = {
  "deadlock-external": "deadlockexternal",
  "deadlock-internal": "deadlockinternal",
  "cs2-internal": "cs2internal",
  "cs2-external": "cs2external",
  "fivem-internal": "fiveminternal",
  "fivem-external": "fivemexternal",
  "roblox-external": "robloxexternal",
  "overwatch-external": "overwatchexternal",
  "marvel-rivals-external": "marvelrivalsexternal",
};

export const salesKey = (id: string): string => SALES_KEYS[id] ?? id;
